import { httpRequest } from "@services/http";

export interface SftpInstructions {
  /** The setup guide as markdown, with the org's SFTP username and host filled in. */
  markdown: string;
}

/** The setup guide as markdown for the SFTP instructions page (MPN-2082). */
export class CommandGetSftpInstructionsMarkdown {
  async run(organizationId: number): Promise<SftpInstructions> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/sftp/${organizationId}/instructions`;
    return httpRequest<SftpInstructions>(url, { method: "GET" });
  }
}
